import moment from "moment";

// Filtros compartidos entre los tabs de reportes (Resultados, Ventas, Gastos).
// Cualquier filtro que tenga que aplicarse de forma transversal entre los tabs
// vive acá. Hoy: el mes de referencia del calendario y el rango de período.

// Rangos que forzan una fecha-fin canónica distinta del endMonth actual.
// Cuando el caller selecciona uno de estos rangos, también sincronizamos
// endMonth para que el calendario y la consulta queden coherentes entre sí.
// Para agregar un nuevo rango con override (previousMonth, previousQuarter…)
// basta con sumar la entrada — la action no cambia.
//
// `previousYear` solía vivir aquí — lo movimos a `resolveDateRange` para que
// el rango sea self-contained y no se rompa cuando el usuario cambia
// endMonth desde el calendario después de haber elegido "Año Anterior".
const RANGE_OVERRIDES = {};

const state = () => ({
    endMonth: moment().toDate(),
    selectedPeriodRange: "lastYear",
    // Rango explícito definido por el usuario via AnualCalendar en modo
    // "range" (hoy sólo Ventas). Cuando viene { from, to }, el caller debe
    // setear selectedPeriodRange = "custom" para que `resolveDateRange` lo use
    // en lugar del rango predefinido. Las fechas son Date objects normalizadas
    // al primer día del mes.
    customRange: null,
});

const mutations = {
    SET_END_MONTH(state, date) {
        state.endMonth = date;
    },
    SET_SELECTED_PERIOD_RANGE(state, range) {
        state.selectedPeriodRange = range;
    },
    SET_CUSTOM_RANGE(state, payload) {
        state.customRange = payload;
    },
};

const actions = {
    setPeriodRange({ commit }, range) {
        commit("SET_SELECTED_PERIOD_RANGE", range);
        const overrideFn = RANGE_OVERRIDES[range];
        if (overrideFn) commit("SET_END_MONTH", overrideFn());
    },
    // Aplica un rango personalizado: switchea selectedPeriodRange a "custom",
    // sincroniza endMonth al `to` del rango (mantiene la coherencia con el
    // calendar pill y con cualquier consumer que mire endMonth aislado) y
    // guarda el rango. `from`/`to` deben ser Date objects.
    setCustomRange({ commit }, range) {
        if (!range || !range.from || !range.to) return;
        commit("SET_CUSTOM_RANGE", range);
        commit("SET_SELECTED_PERIOD_RANGE", "custom");
        commit("SET_END_MONTH", range.to);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
